<template>
  <div>
    <kt-col v-if="user.national_card_file" class="text-center">
      <kt-img-magnifier :src="user.authentication_file" class="mb-4"></kt-img-magnifier>
      <kt-img-magnifier :src="user.national_card_file" class="mb-4"></kt-img-magnifier>
      <kt-img-magnifier
        v-if="user.user_type == user_types.LEGAL"
        :src="user.rrk_latest_change_file"
        class="mb-4"
      >
      </kt-img-magnifier>
    </kt-col>
    <kt-col v-else class="text-center">
      <p class="bg-warning text-dark p-3">
        {{ $t("not_uploaded_yet") }}
      </p>
    </kt-col>

    <kt-col>
      <form
        v-if="status === 'success'"
        id="update_form"
        class="mt-5"
        @submit.prevent="changeUserSetting"
      >
        <kt-form-group>
          <kt-form-label>
            {{ $t("label.change_status") }}
          </kt-form-label>
          <kt-form-select
            id="status"
            v-model="user.status"
            class="form-control kt-selectpicker"
            name="status"
            size="3"
          >
            <option
              v-for="(status, index) in statuses"
              v-bind:key="index"
              :selected="user.status == status.value"
              v-bind:value="status.value"
              @change="checkIfRejectedStatusSelect(user.status)"
            >
              {{ status.name }}
            </option>
          </kt-form-select>
        </kt-form-group>

        <kt-form-group
          v-if="
            user.status == userStatus.AUTHORIZATION_DOCUMENTS_REJECTED ||
            is_rejected_user_status
          "
        >
          <kt-form-label for="rejected_status_description">
            {{ $t("label.auth_documentation_rejection_reason") }}
          </kt-form-label>
          <textarea
            id="rejected_status_description"
            v-model="user.rejected_status_description"
            class="form-control no-resize"
            name="rejected_status_description"
            rows="6"
          ></textarea>
        </kt-form-group>
        <kt-row>
          <kt-col md="6" xs="12">
            <kt-form-action class="mt-4">
              <button
                id="change_status_btn"
                class="btn btn-md btn-success btn-wide"
                type="submit"
              >
                {{ $t("btn.edit") }}
              </button>
            </kt-form-action>
          </kt-col>
          <kt-col md="6" xs="12">
<!--            <kt-form-action class="mt-4">-->
<!--              <button-->
<!--                v-if="hasManageAccess"-->
<!--                id="change_user_access_btn"-->
<!--                class="btn btn-md btn-primary btn-wide"-->
<!--                data-target="#user-access-modal"-->
<!--                data-toggle="modal"-->
<!--                type="button"-->
<!--              >-->
<!--                {{ $t("btn.change_user_access") }}-->
<!--              </button>-->
<!--            </kt-form-action>-->

            <!-- Modal -->
<!--            <div-->
<!--              v-if="user.access"-->
<!--              id="user-access-modal"-->
<!--              class="modal fade"-->
<!--              role="dialog"-->
<!--            >-->
<!--              <div class="modal-dialog">-->
<!--                &lt;!&ndash; Modal content&ndash;&gt;-->
<!--                <div id="user-access-modal-content" class="modal-content">-->
<!--                  <div class="modal-header">-->
<!--                    <h4 class="modal-title">-->
<!--                      {{ $t("label.change_user_access") }}-->
<!--                    </h4>-->
<!--                    <button class="close" data-dismiss="modal" type="button">-->
<!--                      &times;-->
<!--                    </button>-->
<!--                  </div>-->
<!--                  <div class="modal-body">-->
<!--                    <kt-form-section>-->
<!--                      <p>{{ $t("label.choose_user_access") }}</p>-->
<!--                      <kt-form-section>-->
<!--                        <kt-row class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <div id="gateway-div" class="custom-control custom-checkbox">-->
<!--                              <input-->
<!--                                id="manage-gateway"-->
<!--                                v-model="user.access.permissions"-->
<!--                                class="custom-control-input"-->
<!--                                name="manage_gateway"-->
<!--                                type="checkbox"-->
<!--                                :value="Permissions.GATEWAY_MANAGE"-->
<!--                              />-->
<!--                              <label class="custom-control-label" for="manage-gateway">-->
<!--                                {{ $t("label.manage_gateway") }}-->
<!--                              </label>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->
<!--                        <kt-row class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <div id="user-div" class="custom-control custom-checkbox">-->
<!--                              <input-->
<!--                                id="manage-user"-->
<!--                                v-model="user.access.permissions"-->
<!--                                class="custom-control-input"-->
<!--                                name="manage_user"-->
<!--                                type="checkbox"-->
<!--                                :value="Permissions.USER_MANAGE"-->
<!--                              />-->
<!--                              <label class="custom-control-label" for="manage-user">-->
<!--                                {{ $t("label.manage_user") }}-->
<!--                              </label>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->
<!--                        <kt-row class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <div-->
<!--                              id="change_number-div"-->
<!--                              class="custom-control custom-checkbox"-->
<!--                            >-->
<!--                              <input-->
<!--                                id="change_number"-->
<!--                                v-model="user.access.permissions"-->
<!--                                class="custom-control-input"-->
<!--                                name="change_number"-->
<!--                                type="checkbox"-->
<!--                                :value="Permissions.CHANGE_NUMBER_CHANGE"-->
<!--                              />-->
<!--                              <label class="custom-control-label" for="change_number">-->
<!--                                {{ $t("label.change_number") }}-->
<!--                              </label>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->

<!--                        <kt-row class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <div-->
<!--                              id="manage-access-div"-->
<!--                              class="custom-control custom-checkbox"-->
<!--                            >-->
<!--                              <input-->
<!--                                id="manage-access"-->
<!--                                v-model="user.access.permissions"-->
<!--                                class="custom-control-input"-->
<!--                                name="manage_access"-->
<!--                                type="checkbox"-->
<!--                                :value="Permissions.USER_MANAGE_ACCESS"-->
<!--                              />-->
<!--                              <label class="custom-control-label" for="manage-access">-->
<!--                                {{ $t("label.manage_access") }}-->
<!--                              </label>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->
<!--                        <kt-row class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <div-->
<!--                              id="user_excel-div"-->
<!--                              class="custom-control custom-checkbox"-->
<!--                            >-->
<!--                              <input-->
<!--                                id="user_excel"-->
<!--                                v-model="user.access.permissions"-->
<!--                                class="custom-control-input"-->
<!--                                name="user_excel"-->
<!--                                type="checkbox"-->
<!--                                :value="Permissions.USER_ADMIN_EXCEL"-->
<!--                              />-->
<!--                              <label class="custom-control-label" for="user_excel">-->
<!--                                {{ $t("label.user_excel") }}-->
<!--                              </label>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->

<!--                        <kt-row class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <div id="ticket-div" class="custom-control custom-checkbox">-->
<!--                              <input-->
<!--                                id="manage-ticket"-->
<!--                                v-model="user.access.permissions"-->
<!--                                class="custom-control-input"-->
<!--                                name="manage_ticket"-->
<!--                                type="checkbox"-->
<!--                                :value="Permissions.TICKET_MANAGE"-->
<!--                              />-->
<!--                              <label class="custom-control-label" for="manage-ticket">-->
<!--                                {{ $t("label.manage_ticket") }}-->
<!--                              </label>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->
<!--                        <kt-row class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <div-->
<!--                              id="pardakht-shakhsi-div"-->
<!--                              class="custom-control custom-checkbox"-->
<!--                            >-->
<!--                              <input-->
<!--                                id="manage-pardakht-shakhsi"-->
<!--                                v-model="user.access.permissions"-->
<!--                                class="custom-control-input"-->
<!--                                name="manage_pardakht_shakhsi"-->
<!--                                type="checkbox"-->
<!--                                :value="Permissions.PARDAKHT_SHAKHSI_MANAGE"-->
<!--                              />-->
<!--                              <label-->
<!--                                class="custom-control-label"-->
<!--                                for="manage-pardakht-shakhsi"-->
<!--                              >-->
<!--                                {{ $t("label.manage_payment_link") }}-->
<!--                              </label>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->
<!--                        <kt-row class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <div id="news-div" class="custom-control custom-checkbox">-->
<!--                              <input-->
<!--                                id="manage-news"-->
<!--                                v-model="user.access.permissions"-->
<!--                                class="custom-control-input"-->
<!--                                name="manage_news"-->
<!--                                type="checkbox"-->
<!--                                :value="Permissions.NEWS_MANAGE"-->
<!--                              />-->
<!--                              <label class="custom-control-label" for="manage-news">-->
<!--                                {{ $t("label.manage_news") }}-->
<!--                              </label>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->
<!--                        <kt-row class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <div id="pos-div" class="custom-control custom-checkbox">-->
<!--                              <input-->
<!--                                id="manage_pos"-->
<!--                                v-model="user.access.permissions"-->
<!--                                class="custom-control-input"-->
<!--                                name="manage_pos"-->
<!--                                type="checkbox"-->
<!--                                :value="Permissions.POS_MANAGE"-->
<!--                              />-->
<!--                              <label class="custom-control-label" for="manage_pos">-->
<!--                                {{ $t("label.manage_pos") }}-->
<!--                              </label>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->
<!--                        <kt-row class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <div-->
<!--                              id="pos_register-div"-->
<!--                              class="custom-control custom-checkbox"-->
<!--                            >-->
<!--                              <input-->
<!--                                id="manage-pos_register"-->
<!--                                v-model="user.access.permissions"-->
<!--                                class="custom-control-input"-->
<!--                                name="manage_pos_register"-->
<!--                                type="checkbox"-->
<!--                                :value="Permissions.POS_REGISTER"-->
<!--                              />-->
<!--                              <label-->
<!--                                class="custom-control-label"-->
<!--                                for="manage-pos_register"-->
<!--                              >-->
<!--                                {{ $t("label.manage_pos_register") }}-->
<!--                              </label>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->
<!--                        <kt-row class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <div-->
<!--                              id="marketing-div"-->
<!--                              class="custom-control custom-checkbox"-->
<!--                            >-->
<!--                              <input-->
<!--                                id="marketing-access"-->
<!--                                v-model="user.access.permissions"-->
<!--                                class="custom-control-input"-->
<!--                                name="marketing_access"-->
<!--                                type="checkbox"-->
<!--                                :value="Permissions.MARKETING_MANAGE"-->
<!--                              />-->
<!--                              <label class="custom-control-label" for="marketing-access">-->
<!--                                {{ $t("label.marketing_access") }}-->
<!--                              </label>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->
<!--                        <kt-row class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <div-->
<!--                              id="posvisitor-div"-->
<!--                              class="custom-control custom-checkbox"-->
<!--                            >-->
<!--                              <input-->
<!--                                id="posvisitor-access"-->
<!--                                v-model="user.access.permissions"-->
<!--                                class="custom-control-input"-->
<!--                                name="posvisitor_access"-->
<!--                                type="checkbox"-->
<!--                                :value="Permissions.POS_VISITOR"-->
<!--                              />-->
<!--                              <label class="custom-control-label" for="posvisitor-access">-->
<!--                                {{ $t("label.pos_visitor_access") }}-->
<!--                              </label>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->
<!--                        <kt-row class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <div-->
<!--                              id="card_to_card-div"-->
<!--                              class="custom-control custom-checkbox"-->
<!--                            >-->
<!--                              <input-->
<!--                                id="card_to_card-access"-->
<!--                                v-model="user.access.permissions"-->
<!--                                class="custom-control-input"-->
<!--                                name="card_to_card_access"-->
<!--                                type="checkbox"-->
<!--                                :value="Permissions.CARD_TO_CARD_MANAGE"-->
<!--                              />-->
<!--                              <label-->
<!--                                class="custom-control-label"-->
<!--                                for="card_to_card-access"-->
<!--                              >-->
<!--                                {{ $t("label.card_to_card_access") }}-->
<!--                              </label>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->
<!--                        <kt-row class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <div-->
<!--                              id="online_contract_access-div"-->
<!--                              class="custom-control custom-checkbox"-->
<!--                            >-->
<!--                              <input-->
<!--                                id="online_contract_access-access"-->
<!--                                v-model="user.access.permissions"-->
<!--                                class="custom-control-input"-->
<!--                                name="online_contract_access"-->
<!--                                type="checkbox"-->
<!--                                :value="Permissions.ONLINE_CONTRACT_MANAGE"-->
<!--                              />-->
<!--                              <label-->
<!--                                class="custom-control-label"-->
<!--                                for="online_contract_access-access"-->
<!--                              >-->
<!--                                {{ $t("label.online_contract_access") }}-->
<!--                              </label>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->
<!--                        <kt-row v-if="$can('read-telescope', 'monitoring')" class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <div-->
<!--                              id="monitoring-div"-->
<!--                              class="custom-control custom-checkbox"-->
<!--                            >-->
<!--                              <input-->
<!--                                id="monitoring-access"-->
<!--                                v-model="user.access.permissions"-->
<!--                                class="custom-control-input"-->
<!--                                name="monitoring"-->
<!--                                type="checkbox"-->
<!--                                :value="Permissions.MONITORING_MANAGE"-->
<!--                              />-->
<!--                              <label class="custom-control-label" for="monitoring-access">-->
<!--                                {{ $t("label.monitoring") }}-->
<!--                              </label>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->
<!--                        <kt-row class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <hr />-->
<!--                            <p>{{ $t("dashboard.label.transaction") }}</p>-->
<!--                            <div v-for="(role, index) in transaction_roles" :key="index">-->
<!--                              <kt-row class="mb-3">-->
<!--                                <kt-col lg="12" md="12" xs="12">-->
<!--                                  <div-->
<!--                                    id="transaction-div"-->
<!--                                    class="custom-control custom-checkbox"-->
<!--                                  >-->
<!--                                    <input-->
<!--                                      :id="role.key"-->
<!--                                      v-model="user.access.permissions"-->
<!--                                      :name="role.key"-->
<!--                                      class="custom-control-input"-->
<!--                                      type="checkbox"-->
<!--                                      :value="role.key"-->
<!--                                    />-->
<!--                                    <label :for="role.key" class="custom-control-label">-->
<!--                                      {{ role.value }}-->
<!--                                    </label>-->
<!--                                  </div>-->
<!--                                </kt-col>-->
<!--                              </kt-row>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->
<!--                        <kt-row class="mb-3">-->
<!--                          <kt-col lg="12" md="12" xs="12">-->
<!--                            <hr />-->
<!--                            <p>{{ $t("dashboard.label.tech-support") }}</p>-->
<!--                            <div v-for="(role, index) in tech_support_roles" :key="index">-->
<!--                              <kt-row class="mb-3">-->
<!--                                <kt-col lg="12" md="12" xs="12">-->
<!--                                  <div-->
<!--                                    id="tech-support-div"-->
<!--                                    class="custom-control custom-checkbox"-->
<!--                                  >-->
<!--                                    <input-->
<!--                                      :id="role.key"-->
<!--                                      v-model="user.access.permissions"-->
<!--                                      :name="role.key"-->
<!--                                      class="custom-control-input"-->
<!--                                      type="checkbox"-->
<!--                                      :value="role.key"-->
<!--                                    />-->
<!--                                    <label :for="role.key" class="custom-control-label">-->
<!--                                      {{ role.value }}-->
<!--                                    </label>-->
<!--                                  </div>-->
<!--                                </kt-col>-->
<!--                              </kt-row>-->
<!--                            </div>-->
<!--                          </kt-col>-->
<!--                        </kt-row>-->
<!--                        <div v-if="$can('manage', 'wallet')">-->
<!--                          <hr />-->
<!--                          <p>{{ $t("label.wallet") }}</p>-->
<!--                          <div v-for="item in wallet_roles" :key="item.key">-->
<!--                            <kt-row class="mb-3">-->
<!--                              <kt-col lg="12" md="12" xs="12">-->
<!--                                <div-->
<!--                                  id="wallet-div"-->
<!--                                  class="custom-control custom-checkbox"-->
<!--                                >-->
<!--                                  <input-->
<!--                                    :id="item.key"-->
<!--                                    v-model="user.access.permissions"-->
<!--                                    :name="item.key"-->
<!--                                    class="custom-control-input"-->
<!--                                    type="checkbox"-->
<!--                                    :value="item.key"-->
<!--                                  />-->
<!--                                  <label :for="item.key" class="custom-control-label">-->
<!--                                    {{ item.value }}-->
<!--                                  </label>-->
<!--                                </div>-->
<!--                              </kt-col>-->
<!--                            </kt-row>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <div v-if="$can('manage', 'wallet')">-->
<!--                          <hr />-->
<!--                          <p>{{ $t("label.support") }}</p>-->
<!--                          <div v-for="item in support_roles" :key="item.key">-->
<!--                            <kt-row class="mb-3">-->
<!--                              <kt-col lg="12" md="12" xs="12">-->
<!--                                <div-->
<!--                                  id="support-div"-->
<!--                                  class="custom-control custom-checkbox"-->
<!--                                >-->
<!--                                  <input-->
<!--                                    :id="item.key"-->
<!--                                    v-model="user.access.permissions"-->
<!--                                    :name="item.key"-->
<!--                                    class="custom-control-input"-->
<!--                                    type="checkbox"-->
<!--                                    :value="item.key"-->
<!--                                    @change="checkManage(item.key)"-->
<!--                                  />-->
<!--                                  <label :for="item.key" class="custom-control-label">-->
<!--                                    {{ item.value }}-->
<!--                                  </label>-->
<!--                                </div>-->
<!--                              </kt-col>-->
<!--                            </kt-row>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <div v-if="$can('manage', 'wallet-opreator')">-->
<!--                          <hr />-->
<!--                          <p>{{ $t("label.wallet_operator") }}</p>-->
<!--                          <div v-for="item in wallet_operator_roles" :key="item.key">-->
<!--                            <kt-row class="mb-3">-->
<!--                              <kt-col lg="12" md="12" xs="12">-->
<!--                                <div-->
<!--                                  id="wallet-operator-div"-->
<!--                                  class="custom-control custom-checkbox"-->
<!--                                >-->
<!--                                  <input-->
<!--                                    :id="item.key"-->
<!--                                    v-model="user.access.permissions"-->
<!--                                    :name="item.key"-->
<!--                                    class="custom-control-input"-->
<!--                                    type="checkbox"-->
<!--                                    :value="item.key"-->
<!--                                    @change="checkManage(item.key)"-->
<!--                                  />-->
<!--                                  <label :for="item.key" class="custom-control-label">-->
<!--                                    {{ item.value }}-->
<!--                                  </label>-->
<!--                                </div>-->
<!--                              </kt-col>-->
<!--                            </kt-row>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <div v-if="$can('manage', 'accounting')">-->
<!--                          <hr />-->
<!--                          <p>{{ $t("label.accounting") }}</p>-->
<!--                          <div v-for="(item, index) in accounting_roles" :key="index">-->
<!--                            <kt-row class="mb-3">-->
<!--                              <kt-col lg="12" md="12" xs="12">-->
<!--                                <div-->
<!--                                  id="accounting-div"-->
<!--                                  class="custom-control custom-checkbox"-->
<!--                                >-->
<!--                                  <input-->
<!--                                    :id="item.key"-->
<!--                                    v-model="user.access.permissions"-->
<!--                                    :name="item.key"-->
<!--                                    class="custom-control-input"-->
<!--                                    type="checkbox"-->
<!--                                    :value="item.key"-->
<!--                                    @change="checkManage(item.key)"-->
<!--                                  />-->
<!--                                  <label :for="item.key" class="custom-control-label">-->
<!--                                    {{ item.value }}-->
<!--                                  </label>-->
<!--                                </div>-->
<!--                              </kt-col>-->
<!--                            </kt-row>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <div v-if="$can('manage', 'all')">-->
<!--                          <hr />-->
<!--                          <p>{{ $t("label.roles.title") }}</p>-->
<!--                          <div v-for="(item, index) in RolesArray" :key="index">-->
<!--                            <kt-row class="mb-3">-->
<!--                              <kt-col lg="12" md="12" xs="12">-->
<!--                                <div-->
<!--                                  id="accounting-div"-->
<!--                                  class="custom-control custom-checkbox"-->
<!--                                >-->
<!--                                  <input-->
<!--                                    :id="item.key"-->
<!--                                    v-model="user.access.roles"-->
<!--                                    :name="item.key"-->
<!--                                    class="custom-control-input"-->
<!--                                    type="checkbox"-->
<!--                                    :value="item.key"-->
<!--                                  />-->
<!--                                  <label :for="item.key" class="custom-control-label">-->
<!--                                    {{ item.value }}-->
<!--                                  </label>-->
<!--                                </div>-->
<!--                              </kt-col>-->
<!--                            </kt-row>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <kt-form-action class="mt-4">-->
<!--                          <kt-button-->
<!--                            id="submit_access_change_btn"-->
<!--                            class="m-2 btn-wide"-->
<!--                            size="md"-->
<!--                            type="button"-->
<!--                            v-bind:wide="true"-->
<!--                            variant="success"-->
<!--                            @click="changeAccess"-->
<!--                          >-->
<!--                            {{ $t("btn.edit") }}-->
<!--                          </kt-button>-->
<!--                        </kt-form-action>-->

<!--                        <hr />-->
<!--                        <p>{{ $t("label.choose_user_notif") }}</p>-->
<!--                        <form-->
<!--                          v-if="status === 'success'"-->
<!--                          id="update_notification_form"-->
<!--                          @submit.prevent="changeUserNotificationSetting"-->
<!--                        >-->
<!--                          <kt-form-section>-->
<!--                            <kt-row class="mb-3">-->
<!--                              <kt-col lg="12" md="12" xs="12">-->
<!--                                <div-->
<!--                                  id="new_user_notif-div"-->
<!--                                  class="custom-control custom-checkbox"-->
<!--                                >-->
<!--                                  <input-->
<!--                                    id="new_user_notif"-->
<!--                                    v-model="user.notification.send_new_auth"-->
<!--                                    class="custom-control-input"-->
<!--                                    name="send_new_auth"-->
<!--                                    type="checkbox"-->
<!--                                  />-->
<!--                                  <label-->
<!--                                    class="custom-control-label"-->
<!--                                    for="new_user_notif"-->
<!--                                  >-->
<!--                                    {{ $t("label.new_user_notif") }}-->
<!--                                  </label>-->
<!--                                </div>-->
<!--                              </kt-col>-->
<!--                            </kt-row>-->
<!--                            <kt-row class="mb-3">-->
<!--                              <kt-col lg="12" md="12" xs="12">-->
<!--                                <div-->
<!--                                  id="new_gateway_notif-div"-->
<!--                                  class="custom-control custom-checkbox"-->
<!--                                >-->
<!--                                  <input-->
<!--                                    id="new_gateway_notif"-->
<!--                                    v-model="user.notification.send_new_terminal"-->
<!--                                    class="custom-control-input"-->
<!--                                    name="send_new_terminal"-->
<!--                                    type="checkbox"-->
<!--                                  />-->
<!--                                  <label-->
<!--                                    class="custom-control-label"-->
<!--                                    for="new_gateway_notif"-->
<!--                                  >-->
<!--                                    {{ $t("label.new_gateway_notif") }}-->
<!--                                  </label>-->
<!--                                </div>-->
<!--                              </kt-col>-->
<!--                            </kt-row>-->
<!--                            <kt-row class="mb-3">-->
<!--                              <kt-col lg="12" md="12" xs="12">-->
<!--                                <div-->
<!--                                  id="new_ticket_notif-div"-->
<!--                                  class="custom-control custom-checkbox"-->
<!--                                >-->
<!--                                  <input-->
<!--                                    id="new_ticket_notif"-->
<!--                                    v-model="user.notification.send_new_ticket"-->
<!--                                    class="custom-control-input"-->
<!--                                    name="send_new_ticket"-->
<!--                                    type="checkbox"-->
<!--                                  />-->
<!--                                  <label-->
<!--                                    class="custom-control-label"-->
<!--                                    for="new_ticket_notif"-->
<!--                                  >-->
<!--                                    {{ $t("label.new_ticket_notif") }}-->
<!--                                  </label>-->
<!--                                </div>-->
<!--                              </kt-col>-->
<!--                            </kt-row>-->
<!--                          </kt-form-section>-->
<!--                          <kt-form-action class="mt-4">-->
<!--                            <kt-button-->
<!--                              id="submit_notification_change_btn"-->
<!--                              class="m-2 btn-wide"-->
<!--                              size="md"-->
<!--                              type="button"-->
<!--                              v-bind:wide="true"-->
<!--                              variant="success"-->
<!--                              @click="changeUserNotificationSetting"-->
<!--                            >-->
<!--                              {{ $t("btn.notif_edit") }}-->
<!--                            </kt-button>-->
<!--                          </kt-form-action>-->
<!--                        </form>-->
<!--                      </kt-form-section>-->
<!--                    </kt-form-section>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </kt-col>
        </kt-row>
      </form>
    </kt-col>
    <kt-col class="mt-5">
      <div class="line-divider mt-4 mb-3"></div>
      <h6>{{ $t("dashboard.label.last_login") }}</h6>
      <table class="table table-striped login-tbl">
        <thead>
          <tr>
            <td style="width: 20px">#</td>
            <td class="text-center">{{ $t("label.country_flag") }}</td>
            <td>{{ $t("label.ip") }}</td>
            <td>{{ $t("label.date") }}</td>
            <td>{{ $t("label.time") }}</td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(log, index) in user.login_log"
            v-bind:key="index"
            class="login-record"
          >
            <td>{{ index + 1 }}</td>
            <td v-if="log.countryCode != null" class="text-center">
              <country-flag :country="log.countryCode" size="small" />
            </td>
            <td v-else class="text-center">-</td>
            <td>{{ log.ip }}</td>
            <td>{{ log.date }}</td>
            <td>{{ log.time }}</td>
          </tr>
        </tbody>
      </table>
    </kt-col>
    <kt-col>
      <charge-sms-wallet-manually></charge-sms-wallet-manually>
    </kt-col>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { userStatus, userStatusStr } from "@/constants/userStatus";
import { userService } from "@/common/api.service";
import { KTApp } from "@/plugins/core/app";
import $ from "jquery";
import toastr from "toastr";
import { i18n } from "@/plugins/i18n";
import CountryFlag from "vue-country-flag";
import chargeSmsWalletManually from "./charge-sms-wallet-manually";
import { userTypes } from "@/constants/userTypes";
import {
  AccountingPermissions,
  Permissions,
  WalletPermissions,
  SupportPermissions,
  WalletOperatorPermissions,
} from "@/constants/Permissions";
import { RolesArray } from "@/constants/Roles";
import _ from "lodash";

export default {
  components: {
    CountryFlag,
    chargeSmsWalletManually,

  },
  data() {
    return {
      RolesArray,
      Permissions,
      user_types: userTypes,
      statuses: [
        {
          name: userStatusStr.ACTIVE,
          value: userStatus.ACTIVE,
        },
        {
          name: userStatusStr.AUTHORIZATION_DOCUMENTS_REJECTED,
          value: userStatus.AUTHORIZATION_DOCUMENTS_REJECTED,
        },
        {
          name: userStatusStr.REMOVED,
          value: userStatus.REMOVED,
        },
        {
          name: userStatusStr.IS_AUTHENTICATED,
          value: userStatus.IS_AUTHENTICATED,
        },
        {
          name: userStatusStr.IS_AUTHENTICATED_PENDING,
          value: userStatus.IS_AUTHENTICATED_PENDING,
        },
        {
          name: userStatusStr.ENAMAD_AUTHENTICATED,
          value: userStatus.ENAMAD_AUTHENTICATED,
        },
        {
          name: userStatusStr.BLOCK,
          value: userStatus.BLOCK,
        },
        {
          name: userStatusStr.TEMPORARY_BLOCK,
          value: userStatus.TEMPORARY_BLOCK,
        },
        {
          name: userStatusStr.USER_INQUIRY_REJECTED,
          value: userStatus.USER_INQUIRY_REJECTED,
        },
        {
          name: userStatusStr.DEACTIVATED,
          value: userStatus.DEACTIVATED,
        },
      ],
      userStatus: userStatus,
      is_rejected_user_status: false,
      wallet_operator_roles: [
        {
          key: Permissions.WALLET_SETTING_BLOCKED_AMOUNT,
          value: i18n.t("label.wallet_roles.setting_blocked_amount"),
        },
        {
          key: Permissions.WALLET_MANUAL_CHARGE,
          value: i18n.t("label.wallet_roles.manual_charge"),
        },
        {
          key: Permissions.WALLET_AUTO_SETTLEMENT_CREATION,
          value: i18n.t("label.wallet_roles.auto_settlement_creation"),
        },
        {
          key: Permissions.WALLET_ENABLE_DISABLE_WALLET,
          value: i18n.t("label.wallet_roles.wallet_enable_disable"),
        },
        {
          key: Permissions.WALLET_VIEW_SETTLEMENT_DETAILS,
          value: i18n.t("label.wallet_roles.view_settlment_details"),
        },
      ],
      support_roles: [
        {
          key: Permissions.WALLET_SETTING_BLOCKED_AMOUNT,
          value: i18n.t("label.wallet_roles.setting_blocked_amount"),
        },
        {
          key: Permissions.WALLET_VIEW_SETTLEMENT_DETAILS,
          value: i18n.t("label.wallet_roles.view_settlment_details"),
        },
        {
          key: Permissions.WALLET_GENERAL_SETTINGS,
          value: i18n.t("label.wallet_roles.wallet_general_setting"),
        },
        {
          key: Permissions.WALLET_GENERAL_WAGE_SETTINGS,
          value: i18n.t("label.wallet_roles.wallet_general_wage_setting"),
        },
        {
          key: Permissions.WALLET_SPECIFIC_SETTINGS,
          value: i18n.t("label.wallet_roles.wallet_specific_setting"),
        },
        {
          key: Permissions.WALLET_SPECIFIC_WAGE_SETTINGS,
          value: i18n.t("label.wallet_roles.wallet_specific_wage_setting"),
        },
        {
          key: Permissions.WALLET_SCHEDULED_CHARGE,
          value: i18n.t("label.wallet_roles.wallet_schedule_charge"),
        },
        {
          key: Permissions.WALLET_USER_ACCESS_MANAGEMENT,
          value: i18n.t("label.wallet_roles.wallet_user_access_management"),
        },
        {
          key: Permissions.WALLET_ENABLE_DISABLE_WALLET,
          value: i18n.t("label.wallet_roles.wallet_enable_disable"),
        },
      ],
      wallet_roles: [
        {
          key: Permissions.WALLET_MANAGE,
          value: i18n.t("label.wallet_roles.manage"),
        },
        {
          key: Permissions.WALLET_SETTING,
          value: i18n.t("label.wallet_roles.setting"),
        },
        {
          key: Permissions.WALLET_SETTLEMENT,
          value: i18n.t("label.wallet_roles.settlement"),
        },
        {
          key: Permissions.WALLET_CHANGE_STATUS,
          value: i18n.t("label.wallet_roles.change_status"),
        },

        {
          key: Permissions.WALLET_READ,
          value: i18n.t("label.wallet_roles.read"),
        },
        {
          key: Permissions.WALLET_SMS_NOTIFICATION,
          value: i18n.t("label.wallet_roles.sms_notification"),
        },
        {
          key: Permissions.WALLET_TELEGRAM_NOTIFICATION,
          value: i18n.t("label.wallet_roles.telegram_notification"),
        },
        {
          key: Permissions.WALLET_WALLET_TO_WALLET,
          value: i18n.t("label.wallet_roles.wallet_to_wallet"),
        },
        {
          key: Permissions.WALLET_CREATE,
          value: i18n.t("label.wallet_roles.create"),
        },
        {
          key: Permissions.WALLET_PANEL_CREATE_WALLET,
          value: i18n.t("label.wallet_roles.panel_create_wallet"),
        },
        {
          key: Permissions.WALLET_CHARGE_USER_WALLET_BY_RECEIPT,
          value: i18n.t("label.wallet_roles.charge_user_wallet_by_receipt"),
        },
        {
          key: Permissions.WALLET_VIEW_WALLET_LIST,
          value: i18n.t("label.wallet_roles.view_wallet_list"),
        },
        {
          key: Permissions.WALLET_GET_BANK_STATEMENTS,
          value: i18n.t("label.wallet_roles.wallet_view_bank_statements"),
        },
        {
          key: Permissions.WALLET_MANAGE_BANKS,
          value: i18n.t("label.wallet_roles.manage_banks"),
        },
        {
          key: Permissions.WALLET_GET_SETTLEMENT_AND_CHARGE_LIST,
          value: i18n.t("label.wallet_roles.get_settlement_and_charge_list"),
        },
        {
          key: Permissions.WALLET_VIEW_ACCOUNT_BALANCE_RECONCILIATION_MENU,
          value: i18n.t("label.wallet_roles.view_account_balance_reconcilation_menu"),
        },
        {
          key: Permissions.WALLET_VIEW_GENERAL_SETTINGS,
          value: i18n.t("label.wallet_roles.view_general_settings"),
        },
        {
          key: Permissions.WALLET_VIEW_GENERAL_WAGE_SETTINGS,
          value: i18n.t("label.wallet_roles.view_general_wage_settings"),
        },
        {
          key: Permissions.WALLET_VIEW_CUSTOM_WAGE_SETTINGS,
          value: i18n.t("label.wallet_roles.view_custom_wage_settings"),
        },
        {
          key: Permissions.WALLET_VIEW_SPECIFIC_SETTINGS,
          value: i18n.t("label.wallet_roles.view_specific_settings"),
        },
        {
          key: Permissions.WALLET_UPCOMING_SETTLEMENT_SETTINGS,
          value: i18n.t("label.wallet_roles.upcoming_settlement_settings"),
        },
        {
          key: Permissions.WALLET_SETTLEMENT_LIMIT_SETTINGS,
          value: i18n.t("label.wallet_roles.settlement_limit_settings"),
        },
        {
          key: Permissions.WALLET_INTERBANK_TRANSFER,
          value: i18n.t("label.wallet_roles.interbank_transfer"),
        },
        {
          key: Permissions.WALLET_PAYMENT_SETTLEMENT_REQUESTS,
          value: i18n.t("label.wallet_roles.payment_settlement_requests"),
        },
        {
          key: Permissions.WALLET_ENABLE_DISABLE_SETTINGS,
          value: i18n.t("label.wallet_roles.enable_disable_settings"),
        },
      ],
      accounting_roles: [
        {
          key: Permissions.ACCOUNTING_MANAGE,
          value: i18n.t("label.accounting_roles.manage"),
        },
        {
          key: Permissions.ACCOUNTING_READ,
          value: i18n.t("label.accounting_roles.read"),
        },
        {
          key: Permissions.ACCOUNTING_SETTING,
          value: i18n.t("label.accounting_roles.setting"),
        },
        {
          key: Permissions.ACCOUNTING_CREATE_TRANSACTION,
          value: i18n.t("label.accounting_roles.create_transaction"),
        },
        {
          key: Permissions.ACCOUNTING_UPDATE_TRANSACTION,
          value: i18n.t("label.accounting_roles.update_transaction"),
        },
        {
          key: Permissions.ACCOUNTING_DELETE_TRANSACTION,
          value: i18n.t("label.accounting_roles.delete_transaction"),
        },
        {
          key: Permissions.ACCOUNTING_CREATE_BANK_ACCOUNT,
          value: i18n.t("label.accounting_roles.create_bank_account"),
        },
        {
          key: Permissions.ACCOUNTING_UPDATE_BANK_ACCOUNT,
          value: i18n.t("label.accounting_roles.update_bank_account"),
        },
        {
          key: Permissions.ACCOUNTING_DELETE_BANK_ACCOUNT,
          value: i18n.t("label.accounting_roles.delete_bank_account"),
        },
        {
          key: Permissions.ACCOUNTING_NOTIFICATION,
          value: i18n.t("label.accounting_roles.notification"),
        },
        {
          key: Permissions.WALLET_VIEW_STATISTICS,
          value: i18n.t("label.wallet_roles.view_statistics"),
        },
        {
          key: Permissions.WALLET_EXCEL_REQUESTS,
          value: i18n.t("label.wallet_roles.wallet_excel_export"),
        },
        {
          key: Permissions.WALLET_VIEW_SETTLEMENT_DETAILS,
          value: i18n.t("label.wallet_roles.view_settlement_details"),
        },
      ],
      transaction_roles: [
        {
          key: Permissions.TRANSACTION_MANAGE,
          value: i18n.t("label.manage_transaction"),
        },
        {
          key: Permissions.TRANSACTION_WAGE,
          value: i18n.t("label.wage_transaction"),
        },
        {
          key: Permissions.TRANSACTION_CHANGE_STATUS,
          value: i18n.t("label.change_transaction_status"),
        },
        {
          key: Permissions.TRANSACTION_ADMIN_EXCEL,
          value: i18n.t("label.transaction_excel"),
        },
        {
          key: Permissions.TRANSACTION_INQUIRY,
          value: i18n.t("label.transaction_inquiry"),
        },
        {
          key: Permissions.SETTLEMENT_ADMIN_EXCEL,
          value: i18n.t("label.settlement_excel"),
        },
      ],
      tech_support_roles: [
        {
          key: Permissions.TECH_SUPPORT_ACTION,
          value: i18n.t("label.tech_support_role.action"),
        },
        {
          key: Permissions.WALLET_MANUAL_CHARGE,
          value: i18n.t("label.wallet_roles.manual_charge"),
        },
        {
          key: Permissions.WALLET_AUTO_SETTLEMENT_CREATION,
          value: i18n.t("label.wallet_roles.auto_settlement_creation"),
        },
        {
          key: Permissions.WALLET_SCHEDULED_CHARGE,
          value: i18n.t("label.wallet_roles.wallet_schedule_charge"),
        },
        {
          key: Permissions.WALLET_USER_ACCESS_MANAGEMENT,
          value: i18n.t("label.wallet_roles.wallet_user_access_management")
        }
      ],
    };
  },
  computed: {
    ...mapGetters("user", ["user", "current_user", "status"]),
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false,
      };

      return toastr;
    },
    hasManageAccess() {
      let hasAccess = this.current_user.permissions
        .filter((permissions) => permissions.subject === "user-manager")[0]
        .actions.includes("change-access");
      let hasAllAccess =
        this.current_user.permissions.filter(
          (permissions) => permissions.subject === "all"
        ).length > 0;

      return hasAccess || hasAllAccess;
    },
  },
  methods: {
    checkManage(permission) {
      if (permission.includes("manage")) {
        if (
          this.user.access.permissions.includes(Permissions.SUPPORT_MANAGE) &&
          permission === Permissions.SUPPORT_MANAGE
        ) {
          this.changeSupportPermission();
        }
      }
    },
    changeWalletPermission() {
      this.user.access.permissions = [
        ...new Set(this.user.access.permissions.concat(WalletPermissions)),
      ];
    },
    changeWalletOperatorPermission() {
      this.user.access.permissions = [
        ...new Set(this.user.access.permissions.concat(WalletOperatorPermissions)),
      ];
    },
    changeAccountingPermission() {
      this.user.access.permissions = [
        ...new Set(this.user.access.permissions.concat(AccountingPermissions)),
      ];
    },
    changeSupportPermission() {
      this.user.access.permissions = [
        ...new Set(this.user.access.permissions.concat(SupportPermissions)),
      ];
    },
    checkIfRejectedStatusSelect(status) {
      this.is_rejected_user_status =
        status == userStatus.AUTHORIZATION_DOCUMENTS_REJECTED;
    },
    changeUserSetting(e) {
      let btn = $("#change_status_btn");
      let form = $("#update_form");

      KTApp.progress(btn);

      if (this.user.status != userStatus.AUTHORIZATION_DOCUMENTS_REJECTED)
        this.user.rejected_status_description = "";

      userService
        .changeUserSetting(
          this.user.id,
          this.user.status,
        )
        .then((response) => {
          this.showMsg(form, "success", response.data.message);
          this.$store.dispatch("badgeCounter/countData");
        })
        .catch(({ response }) => {
          this.showMsg(form, "danger", response.data.message);
        })
        .finally((response) => {
          KTApp.unprogress(btn);
        });
    },
    changeAccess(e) {
      let form = $("#user-access-modal-content");
      let btn = $("#submit_access_change_btn");
      KTApp.progress(btn);

      userService
        .changeAccess(this.user.id, {
          permissions: this.user.access.permissions,
          roles: this.user.access.roles,
        })
        .then((response) => {
          this.toastr.success(response.data.message);
        })
        .catch(({ response }) => {
          this.toastr.error(response.data.message);
        })
        .finally(() => {
          KTApp.unprogress(btn);
        });
    },
    changeUserNotificationSetting(e) {
      let btn = $("#submit_notification_change_btn");
      let form = $("#update_notification_form");

      KTApp.progress(btn);

      userService
        .changeNotificationAccess(this.user.id, {
          send_new_auth: this.user.notification.send_new_auth,
          send_new_terminal: this.user.notification.send_new_terminal,
          send_new_ticket: this.user.notification.send_new_ticket,
        })
        .then((response) => {
          this.toastr.success(response.data.message);
        })
        .catch(({ response }) => {
          this.toastr.error(response.data.message);
        })
        .finally(() => {
          KTApp.unprogress(btn);
        });
    },
  },
};
</script>

<style>
.modal .modal-content .modal-header .close:before {
  content: "" !important;
}

.modal .modal-content .modal-header .close {
  font-size: 1.8rem;
  line-height: 0.7;
}

.dropdown.bootstrap-select.form-control.kt-.dropup
  .dropdown-menu
  .inner
  ul.dropdown-menu.inner {
  min-width: initial !important;
}

.vSelect {
  --vs-actions-padding: 0;
  --vs-border-color: #fff;
}

</style>
